<template>
    <div class="m--t-2">
        <draggable v-model="selectedColumns" handle=".handle" class="catalogue-selected-items">
            <div :key="selectedColumn.id" v-for="selectedColumn in selectedColumns" class="catalogue-selected-item">
                <div class="handle catalogue-selected-item__handle"></div>
                <div class="catalogue-selected-item__label">
                    {{ messages[selectedColumn.type] }}
                </div>

                <div :key="option.id" v-for="option in selectedColumn.options">
                    <label class="switcher"
                           v-bind:class="{'switcher--focused': focused.indexOf(selectedColumn.id) !== -1}">
                        <input type="checkbox"
                               :value="option.id"
                               @change="changeOption({definitionId: selectedColumn.id, optionId: option.id})"
                               :checked="projectOption(selectedColumn.id, option.id).enabled"
                               @focus="onFocus(selectedColumn.id)"
                               @blur="onBlur(selectedColumn.id)"
                        />
                        <span class="switcher__label">
                            {{ messages[option.type] }}
                        </span>
                    </label>
                </div>
            </div>
        </draggable>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import {messages} from '@/modules/ProjectModule/modules/ExtensionModule/messages/catalogue';

export default {
    name:       'CatalogueColumnSelected',
    components: {
        draggable
    },
    data() {
        return {
            focused: [],
            messages
        }
    },
    computed:   {
        selectedColumns: {
            get() {
                return this.$store.getters['projects/project/extension/catalogue/selectedColumnDefinitions'];
            },
            set(value) {
                this.$store.dispatch('projects/project/extension/catalogue/changeProjectColumnDefinitionPosition', value);
            }
        }
    },
    methods:    {
        projectOption(definitionId, optionId) {
            return this.$store.getters['projects/project/extension/catalogue/getProjectColumnOption'](definitionId, optionId);
        },
        isActive(definitionId) {
            return this.$store.getters['projects/project/extension/catalogue/isProjectColumnActive'](definitionId) ? true : false;
        },
        changeOption(data) {
            this.$store.dispatch('projects/project/extension/catalogue/changeProjectColumnDefinitionOption', data);
        },
        onFocus(columnId) {
            if (this.focused.indexOf(columnId) === -1) {
                this.focused.push(columnId);
            }
        },
        onBlur(columnId) {
            const index = this.focused.indexOf(columnId);
            if (index !== -1) {
                this.focused.splice(index, 1);
            }
        }
    }
}
</script>
